import { render, staticRenderFns } from "./footlist.vue?vue&type=template&id=6406169e&scoped=true&"
import script from "./footlist.vue?vue&type=script&lang=js&"
export * from "./footlist.vue?vue&type=script&lang=js&"
import style0 from "./footlist.vue?vue&type=style&index=0&id=6406169e&lang=scss&scoped=true&"
import style1 from "./footlist.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6406169e",
  null
  
)

export default component.exports